module.exports = __webpack_public_path__ + "static/media/bromley-arena-microsites.759b5226.md";